/* Plushie Patch theme — global JS */
(function () {
  function toggleNav(btn) {
    var header = btn.closest('header');
    var open = header.classList.toggle('nav-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  window.toggleNav = toggleNav;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('header.site-header .menu a').forEach(function (a) {
      a.addEventListener('click', function () {
        var h = document.querySelector('header.site-header');
        if (!h) return;
        h.classList.remove('nav-open');
        var b = h.querySelector('.burger');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  });
})();
